// extracted by mini-css-extract-plugin
export default {"wrapper":"ImageUploader_wrapper__xWAYF","selectImage":"ImageUploader_selectImage__tw35+","label":"ImageUploader_label__i6Ud7"};